module.exports = __webpack_public_path__ + "static/media/IMG_0860.638cb099.jpg";